import * as React from "react";

import { style, Icon } from "./Symbolicons";

export const HandWithPhoneRefresh = (props: Icon): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="188"
    height="250"
    fill="none"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <path
      fill="#004A7A"
      d="M181.498 188.36c-18.169 48.328-72.075 72.777-120.403 54.608-48.328-18.169-72.777-72.075-54.608-120.403C24.656 74.237 78.562 49.788 126.89 67.957c48.328 18.169 72.777 72.075 54.608 120.403z"
    ></path>
    <path
      fill="#BCE4F0"
      d="M159.74 222.116a93.495 93.495 0 01-66.118 27.353l.041-93.488 66.077 66.135z"
    ></path>
    <path
      stroke="url(#a)"
      strokeLinecap="round"
      strokeWidth="0.165"
      d="M131.32 163.67c.783 2.015.237 10.362-9.024 13.202-11.404 3.496-6.266 4.553-12.163 11.293"
    ></path>
    <path
      fill="#BCE4F0"
      fillRule="evenodd"
      d="M113.19 112.353c-1.949-7.247-1.498-11.243-.234-10.298 1.579 1.181 19.409 26.8 21.199 32.206.323.975 1.082 2.725 2.073 5.008 2.477 5.708 6.402 14.754 8.581 23.384.389 1.301.724 2.787.965 4.463.724 4.118.89 7.977.119 11.129-.432 4.258-1.4 9.15-3.135 14.705.193.803 1.614 3.056 3.666 6.308 3.456 5.478 8.7 13.79 12.867 22.776l-17.115 7.912c-3.91 2.188-45.415 25.18-48.69 15.645-3.956-11.524-15.011-22.402-25.333-32.559-7.195-7.08-14.033-13.81-17.863-20.163-1.754-2.91-1.675-8.347-1.583-14.671.113-7.731.245-16.786-2.928-24.171 21.754 1.431 51.833 1.346 72.251 1.289 2.242-.006 4.368-.012 6.354-.016a5322.492 5322.492 0 01-11.194-42.947z"
      clipRule="evenodd"
    ></path>
    <path
      stroke="url(#b)"
      strokeLinecap="round"
      strokeWidth="0.165"
      d="M143.717 191.762c-2.888 3.24-4.894 5.028-10.001 2.237"
    ></path>
    <path
      stroke="url(#c)"
      strokeLinecap="round"
      strokeWidth="0.165"
      d="M128.428 170.539c4.828 10.504-7.91 13.063-9.862 22.874"
    ></path>
    <path
      stroke="url(#d)"
      strokeLinecap="round"
      strokeWidth="0.165"
      d="M145.817 202.024c-6.137 3.298-10.312 6.361-19.7 4.969"
    ></path>
    <path
      fill="url(#e)"
      d="M50.864 193.426c-3.027-3.481 79.87-13.08 76.804-23.182-3.067-10.102-1.524-7.328-.16-2.16 1.363 5.167-3.544 10.938-3.544 10.938l-66.775 22.166s-3.297-4.28-6.325-7.762z"
    ></path>
    <path
      fill="#004A7A"
      d="M83.648 7.554a7.42 7.42 0 00-8.687-5.3L12.307 15.47a7.42 7.42 0 00-5.695 8.94l38.261 164.55a7.42 7.42 0 008.82 5.566l68.939-15.149a7.42 7.42 0 005.563-9.207L83.648 7.554z"
    ></path>
    <path
      fill="#E4F4F9"
      stroke="#004A7A"
      strokeWidth="0.824"
      d="M77.437 2.167L14.683 15.45a7.008 7.008 0 00-5.372 8.455l38.04 162.282a7.007 7.007 0 008.423 5.223l66.007-15.489a7.008 7.008 0 005.185-8.573L85.673 7.272a7.007 7.007 0 00-8.236-5.105z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth="0.165"
      d="M118.414 132.183l11.66-5.459m-10.979 8.149l12.431-5.636"
    ></path>
    <path
      fill="url(#f)"
      d="M39.79 151.776l18.666 1.186s1.197-.326-.323.699-17.455 4.393-17.455 4.393l-.887-6.278z"
    ></path>
    <path
      fill="url(#g)"
      d="M42.098 166.396l16.804-1.465-.404.968s-2.14 2.246-7.482 3.391c-5.342 1.145-8.918 1.233-8.918 1.233v-4.127z"
    ></path>
    <path
      fill="#BCE4F0"
      d="M28.725 119.683c-16.716-2.028-40.574-2.665 3.64 15.727l-3.64-15.727z"
    ></path>
    <path
      fill="url(#h)"
      d="M28.716 119.584l3.676 15.855-2.05-.83-7.78-15.548 6.154.523z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="1.649"
      d="M.824-.824h57.668"
      transform="matrix(.9764 -.21727 .20207 .97911 42.604 131.936)"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="3.298"
      d="M1.649-1.649h30.724"
      transform="matrix(.97655 -.21654 .20139 .97925 41.946 126.912)"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="1.649"
      d="M.824-.824h17.563"
      transform="matrix(.97767 -.2114 .19657 .98023 43.65 136.272)"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="1.649"
      d="M.824-.824h39.214"
      transform="matrix(.97566 -.22057 .20516 .97846 65.296 131.491)"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="1.649"
      d="M.824-.824h44.542"
      transform="matrix(.9771 -.21405 .19906 .97973 44.801 141.559)"
    ></path>
    <path
      fill="#BCE4F0"
      d="M34.08 153.578c23.277 3.918 45.668-.838-.258-18.147l.257 18.147z"
    ></path>
    <path
      fill="#BCE4F0"
      d="M33.822 135.431c-11.06.238-15.692 7.691.257 18.147l-.257-18.147zm6.741 33.316c17.755.729 33.733-5.424-2.138-14.028l2.138 14.028zm-2.138-14.028c-8.251 1.223-10.71 7.714 2.138 14.028l-2.138-14.028z"
    ></path>
    <path
      stroke="#fff"
      strokeWidth="0.165"
      d="M52.431 152.356c1.429.34 3.218.405 4.696.173.74-.117 1.395-.307 1.888-.57.494-.265.811-.596.898-.99.088-.394-.058-.836-.392-1.297-.332-.461-.843-.929-1.459-1.369-1.232-.879-2.87-1.632-4.298-1.973-1.428-.34-2.36-.201-2.979.217-.62.418-.946 1.128-1.134 1.974-.187.846-.192 1.633.19 2.29.383.656 1.162 1.204 2.59 1.545zm1.349 14.238c1.238.148 2.757.026 3.984-.316.614-.172 1.15-.397 1.542-.667.392-.272.627-.581.664-.918.038-.336-.124-.693-.447-1.049-.322-.355-.796-.701-1.357-1.011-1.121-.622-2.574-1.097-3.812-1.244-1.238-.147-2.01.063-2.491.474-.483.412-.694 1.041-.775 1.775-.081.733-.013 1.395.368 1.91.38.514 1.086.899 2.324 1.046z"
    ></path>
    <path
      stroke="#BCE4F0"
      strokeLinecap="round"
      strokeWidth="1.649"
      d="M.824-.824h8.95"
      transform="matrix(.97863 -.20561 .19126 .98154 11.375 26.34)"
    ></path>
    <path
      stroke="#BCE4F0"
      strokeLinecap="round"
      strokeWidth="1.649"
      d="M.824-.824h.646"
      transform="matrix(.96756 -.25263 .23535 .97191 64.566 15.21)"
    ></path>
    <path
      stroke="#BCE4F0"
      strokeLinecap="round"
      strokeWidth="1.649"
      d="M.824-.824h.646"
      transform="matrix(.96756 -.25263 .23535 .97191 70.934 13.734)"
    ></path>
    <path
      stroke="#BCE4F0"
      strokeLinecap="round"
      strokeWidth="1.649"
      d="M.824-.824h.646"
      transform="matrix(.96756 -.25263 .23535 .97191 77.351 12.19)"
    ></path>
    <path
      stroke="#BCE4F0"
      strokeLinecap="round"
      strokeWidth="1.649"
      d="M.824-.824h8.95"
      transform="matrix(.97863 -.20561 .19126 .98154 24.314 23.389)"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="1.649"
      d="M.824-.824h57.667"
      transform="matrix(.9779 -.20984 .19516 .98061 34.092 100.609)"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="3.298"
      d="M1.649-1.649h30.723"
      transform="matrix(.97806 -.20911 .19447 .98075 33.47 95.58)"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="1.649"
      d="M.824-.824h17.563"
      transform="matrix(.97915 -.20396 .18965 .9817 35.107 104.953)"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="1.649"
      d="M.824-.824h39.213"
      transform="matrix(.9772 -.21315 .19825 .97999 56.786 100.336)"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="1.649"
      d="M.824-.824h44.542"
      transform="matrix(.9786 -.20662 .19214 .98121 36.221 110.248)"
    ></path>
    <path
      fill="url(#i)"
      d="M22.115 77.738l79.579-10.946 4.143 17.451-77.654 18.653-6.068-25.158z"
    ></path>
    <path
      fill="url(#j)"
      d="M109.857 100.778l17.875 70.881-1.16 5.338-17.766-73.068 1.051-3.151z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="1.649"
      d="M.824-.824h54.607"
      transform="matrix(.9755 -.2215 .20602 .97823 21.272 43.96)"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="3.298"
      d="M1.649-1.649h28.968"
      transform="matrix(.97567 -.22077 .20533 .97837 20.63 39.2)"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="1.649"
      d="M.824-.824h16.572"
      transform="matrix(.9768 -.21563 .20052 .97938 22.281 48.07)"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="1.649"
      d="M.824-.824h37.105"
      transform="matrix(.97475 -.2248 .2091 .97757 42.791 43.445)"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="1.649"
      d="M.824-.824h42.159"
      transform="matrix(.97622 -.21829 .203 .97886 23.393 53.078)"
    ></path>
    <path
      fill="#fff"
      stroke="#1EA6D1"
      strokeWidth="0.824"
      d="M114.191 93.347l-8.065-39.393a7.015 7.015 0 00-8.359-5.45L18.76 65.664a7 7 0 00-5.331 8.429l9.336 40.144a7.015 7.015 0 008.405 5.248l77.736-17.911a7 7 0 005.285-8.227z"
    ></path>
    <path
      stroke="#1EA6D1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M81.853 86.137l-4.574 2.633-2.64-4.563"
    ></path>
    <path
      stroke="#1EA6D1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M56.353 68.405a14.913 14.913 0 0111.333-1.488c7.966 2.131 12.695 10.303 10.56 18.255a14.955 14.955 0 01-1.216 3.082M45.787 76.48l4.573-2.633L53 78.41"
    ></path>
    <path
      stroke="#1EA6D1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M71.286 94.212A14.913 14.913 0 0159.954 95.7c-7.967-2.131-12.695-10.303-10.561-18.255a14.96 14.96 0 011.217-3.082"
    ></path>
    <defs>
      <linearGradient
        id="a"
        x1="121.603"
        x2="120.103"
        y1="163.101"
        y2="188.748"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="0.453" stopColor="#fff"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="b"
        x1="136.586"
        x2="143.884"
        y1="194.857"
        y2="192.218"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.396" stopColor="#fff"></stop>
        <stop offset="0.911" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="c"
        x1="122.805"
        x2="124.788"
        y1="196.38"
        y2="173.707"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.042" stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="0.396" stopColor="#fff"></stop>
        <stop offset="0.911" stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="d"
        x1="133.071"
        x2="145.966"
        y1="204.966"
        y2="204.023"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.396" stopColor="#fff"></stop>
        <stop offset="0.911" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="e"
        x1="85.661"
        x2="104.756"
        y1="164.059"
        y2="222.748"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.022" stopColor="#004A7A"></stop>
        <stop offset="0.433" stopColor="#004A7A" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="f"
        x1="47.757"
        x2="49.299"
        y1="147.802"
        y2="159.696"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.223" stopColor="#004A7A"></stop>
        <stop offset="0.683" stopColor="#004A7A" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="g"
        x1="48.447"
        x2="50.389"
        y1="162.455"
        y2="171.662"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A7A"></stop>
        <stop offset="0.727" stopColor="#004A7A" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="h"
        x1="36.151"
        x2="23.265"
        y1="124.489"
        y2="128.056"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A7A"></stop>
        <stop offset="0.727" stopColor="#004A7A" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="i"
        x1="60.831"
        x2="73.864"
        y1="59.605"
        y2="104.43"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A7A"></stop>
        <stop offset="0.674" stopColor="#004A7A" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="j"
        x1="131.268"
        x2="85.06"
        y1="136.124"
        y2="146.536"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A7A"></stop>
        <stop offset="0.278" stopColor="#004A7A" stopOpacity="0"></stop>
      </linearGradient>
    </defs>
  </svg>
);
